import { AppSettings } from "fg-library";
import { FG_ROUTE_DATA } from "fg-library";
import { CLIENT_ROUTE_DATA } from "./routes-configuration";
export class AppConfigSettings {
    static settings = {};

    constructor() { }

    public static setSettings() {
        AppSettings.mainToolbar.showLogo = true;
        AppSettings.mainToolbar.showToggleMenu = true;
        AppSettings.mainToolbar.showAppTitle = true;
        AppSettings.mainToolbar.hideToggleMenu = true;

        AppSettings.topNav.showLogo = false;
        AppSettings.topNav.showApps = true;
        AppSettings.topNav.showLogout = false;
        // AppSettings.topNav.showAccount = true;
        AppSettings.topNav.showLoginInfo = false;

        AppSettings.topNav.enableThemeSwitcher = true;

        AppSettings.sidenav.showAppTitle = true;
        AppSettings.appConfig.customToolbarConfig = false;
        AppSettings.appConfig.notificationConfig.notoficationsFromJson = false;
        AppSettings.appConfig.notificationConfig.enableNotification = false;

       
        AppSettings.fixedMainNav = true;
        AppSettings.fixedToolBars = true;
        AppSettings.name = "Kotak";
        AppSettings.spinner = {
            color: '',
            customImgPath: 'assets/img/fingress.gif',
            customImgWidth: '',
            customImgHeight: '',
        };

        AppConfigSettings.settings = AppSettings
        // //console.log(AppConfigSettings.settings)

        // AppSettings.appConfig = {
        //     "fetchBuisnessCodesFromCdn": false,
        //     "showCookieConsent": false,
        //     "cookieConsentMessage": "This website saves information such as cookies in order to provide features such as analytics and personalisation. By continuing to use this website, you consent to our use of cookies.",
        //     preserveUrlQueryParams: false,
        //     notificationConfig: { "enableNotification": false, "functionId": "", formId: "fd9e5374-8c55-4867-8de1-b4feca582e99", appId: "c9a63bba-ec5e-441f-bd16-0c6796b777a6", "notoficationsFromJson": true },
        //     idelTimeConfig: {
        //         "enableIdleTimeConfig": false,
        //         "ideTimeInSeconds": 0,
        //         "functionId": '',
        //         "modalWidth": '',
        //         "modalHeight": '',
        //         "customClass": '',
        //         "disableClose": false
        //     },
        //     "customLayoutConfig": {
        //         "createPageId": "06e7f2f7-4ed9-4293-999d-d1e5793c5f1b",
        //         "associatePageId": "35150a24-298a-4d93-a526-63a98a0b1e4e",
        //         "modityAssociatePageId": "4d32e444-f4b5-4caa-b84d-b575c461058d",
        //         "editPageId": "4175c2fb-f277-4684-81d1-b4453567274c",
        //         "viewPageId": "23fd1364-85cb-4d90-a41f-5db225f28638"
        //     },
        //     customToolbarConfig: false
        // }
        FG_ROUTE_DATA.ROUTES =CLIENT_ROUTE_DATA.ROUTES;
    }
}